<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
     <z-page title="Ternakan">
      <div class="table_scrol">
      <div class="w-card__content content-hardcode">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis_id" label="Premis" />
              <w-input style="margin:5px; " v-model="pencarian.kode" label="ID Ternakan" />
              <z-select style="margin:5px; "  class="mt4" :items="lkp_ternakan" label="Jenis Ternakan" v-model="pencarian.lkp_ternakan_id" @input="getJurusanCarian(pencarian.lkp_ternakan_id)" />
              <z-select style="margin:5px; " class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan"  v-model="pencarian.lkp_jurusan_id" @input="getBakaCarian(pencarian.lkp_jurusan_id)" />        
           </w-flex>
           <w-flex class="mt3" style="width: 868px">
              <z-select style="margin:5px; " v-model="pencarian.lkp_baka_id" :items="lkp_baka" label="Baka" />
              <z-select style="margin:5px; " v-model="pencarian.lkp_gred_id" :items="lkp_gred" label="Gred" />
              <z-select style="margin:5px; " v-model="pencarian.jantina" :items="jantina" label="Jantina" />
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
              <!-- <w-button bg-color="success" @click="cetak()" class="mr2">
                  <w-icon>fal fa-print</w-icon>&nbsp;Cetak</w-button> -->
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;RESET</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
        <z-table title="Senarai Ternakan" :headers="table.headers" :items="table.items" :meta="table.meta" >
         <template #item-cell.umur="{ item, label, header, index }">
            <template v-if="item.tarikh_lahir">{{$zutil.umur(item.tarikh_lahir)}}</template>
         </template>
         <template #item-cell.premis="{ item, label, header, index }"><div style="width: 200px"></div>
            <w-select class="mt4" :items="premis"  v-model="item.premis_id" placeholder="Pilih satu." :validators="[validators.required]" />
         </template>
         <template #item-cell.ternakan="{ item, label, header, index }"><div style="width: 100px"></div>
            <w-select class="mt4" :items="lkp_ternakan"  v-model="item.lkp_ternakan_id" placeholder="Pilih satu."  @input="getJurusan(item)" :validators="[validators.required]"/>
         </template>
         <template #item-cell.jurusan="{ item, label, header, index }"><div style="width: 100px"></div>
            <w-select class="mt4" :items="item.lookup.lkp_jurusan"   v-model="item.lkp_jurusan_id" placeholder="Pilih satu."  @input="getBaka(item)" :validators="[validators.required]"/> 
         </template>
         <template #item-cell.baka="{ item, label, header, index }"><div style="width: 120px"></div>
            <w-select class="mt4" :items="item.lookup.lkp_baka"   v-model="item.lkp_baka_id" placeholder="Pilih satu."  :validators="[validators.required]"/> 
         </template>
         <template #item-cell.kode="{ item, label, header, index }"><div style="width: 230px"></div>
            <table>
              <tbody>
               <tr style="background: none !important">
                  <td ><div style="margin-top: 20px;">Ada<w-checkbox v-model="item.id_ternakan"></w-checkbox></div></td>
                  <td style="margin-top: 20px;">
                     <template v-if="item.id_ternakan == true">
                        <w-input class="mt4"  type="text" v-model="item.kode" :validators="[validators.required]"/>
                     </template>
                     <template v-else>
                        <w-input class="mt4"  type="text" v-model="item.kode" disabled/>
                     </template>
                  </td>
               </tr>
               </tbody>
            </table>
         </template>
         <template #item-cell.gred="{ item, label, header, index }"><div style="width: 100px"></div>
            <w-select class="mt4" :items="lkp_gred"  v-model="item.lkp_gred_id" placeholder="Pilih satu." :validators="[validators.required]"/>
         </template>

         <template #item-cell.nama="{ item, label, header, index }"><div style="width: 120px"></div>
            <w-input class="mt4"  type="text" v-model="item.nama" />
         </template>
         <template #item-cell.tarikh_lahir="{ item, label, header, index }"><div style="width: 120px"></div>
            <w-input class="mt4"  type="date" v-model="item.tarikh_lahir" :validators="[validators.required]"/>
         </template>
         <template #item-cell.jantina_label="{ item, label, header, index }"><div style="width: 120px"></div>
           <w-select class="mt4" :items="jantina" v-model="item.jantina"  :validators="[validators.required]"/>
         </template>
          <template #item-cell.nama_bapa="{ item, label, header, index }"><div style="width: 120px"></div>
            <w-input class="mt4"  type="text" v-model="item.nama_bapa" />
         </template>
         <template #item-cell.id_bapa="{ item, label, header, index }"><div style="width: 120px"></div>
            <w-input class="mt4"  type="text" v-model="item.id_bapa" />
         </template>
         <template #item-cell.nama_ibu="{ item, label, header, index }"><div style="width: 120px"></div>
            <w-input class="mt4"  type="text" v-model="item.nama_ibu" />
         </template>
         <template #item-cell.id_ibu="{ item, label, header, index }"><div style="width: 120px"></div>
            <w-input class="mt4"  type="text" v-model="item.id_ibu" />
         </template>


          <template #header-label="{ header, label, index }">
            <template v-if="header.key == 'action'">Tindakan</template>
            <template v-else>{{ label }}</template>
          </template>
          <template #item-cell.action="{ item, label, header, index }">
            <w-flex class="flex justify-center">
               <w-tooltip md top align-left color="white" bg-color="black" >
                 <template #activator="{ on }">
                  <w-button  bg-color="primary" v-on="on" @click="simpan(item)" class="be fs-2" v-if="loading == false"><div style="width: 8px" ></div><w-icon md class="mr2" >fal fa-save</w-icon></w-button>
                  <w-button  bg-color="primary"  disabled class="be fs-2" v-if="loading == true"><div style="width: 8px" ></div><w-icon md class="mr2" >fal fa-save</w-icon></w-button>
                </template>
                 Simpan
               </w-tooltip>
               <template v-if="item.id != 0">
                  &nbsp;   
               <w-tooltip top color="white" bg-color="black">
                 <template #activator="{ on }">
                     <inertia-link :href="$route('daftar.ternakan.show',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> <w-icon md class="mr2">fal fa-eye</w-icon></inertia-link>
                  </template>
                 Papar
               </w-tooltip>
                  &nbsp; 
               <w-tooltip top align-right color="white" bg-color="black">
                 <template #activator="{ on }">
                   <w-button  bg-color="info" @click="copy(item)" v-on="on" class="be fs-2"><div style="width: 8px"></div><w-icon md class="mr2" >fal fa-copy</w-icon></w-button>
                   </template>
                 Salin
               </w-tooltip>
              </template>
            </w-flex>
          </template>
        </z-table>
      </div>
     </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'


export default {
  
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'daftar.ternakan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Ternakan', route: 'daftar/ternakan' },
      ],
      title : 'Tambah Ternakan',
      form : {
        id : 0,
        premis_id : '',
        lkp_ternakan_id : '',
        lkp_baka_id : '',
        lkp_gred_id : '',
        kode : '',
        nama : '',
        tarikh_lahir : '',
        jantina : '',
        lkp_jurusan_id : '',
        lkp_status_id: '',
        nama_bapa:'',
        id_bapa:'',
        nama_ibu:'',
        id_ibu:'',
        copy : 0
      },
         pencarian: {
         premis_id: '',
         no_ternakan: '',
         lkp_ternakan_id: '',
         lkp_baka_id: '',
         lkp_jurusan_id: '',
         lkp_gred_id: '',
         kode :'',
         jantina: '',
      },
      loading : false,
      lkp_jurusan :[],
      lkp_ternakan : [],
      lkp_baka : [],
      premis : [],
      premis_id : [],
      lkp_gred : [],
      lkp_status : [],
      lkp_negeri : [],
      lkp_bandar : [],
      lkp_poskod : [],
      jantina : []
      
    }
  },
  methods: {
      add(){
          this.form = {
              id : 0,
              premis_id : '',
              lkp_ternakan_id : '',
              lkp_baka_id : '',
              lkp_gred_id : '',
              kode : '',
              nama : '',
              tarikh_lahir : '',
              jantina : '',
              lkp_jurusan_id : '',
              lkp_status_id : '',
              nama_bapa : '',
              id_bapa : '',
              nama_ibu : '',
              id_ibu : '',
              copy : 0

          }
          
          this.dialog.show = true
          this.dialog.title = 'Tambah'
          this.form.saveButton = "Simpan"
      },
      edit(item){
          this.form = {
              id : item.id,
              premis_id : item.premis_id,
              lkp_ternakan_id : item.lkp_ternakan_id,
              lkp_baka_id : item.lkp_baka_id,
              lkp_gred_id : item.lkp_gred_id,
              kode : item.kode,
              nama : item.nama,
              nama_bapa : item.nama_bapa,
              id_bapa : item.id_bapa,
              nama_ibu : item.nama_ibu,
              id_ibu : item.id_ibu,
              tarikh_lahir : item.tarikh_lahir,
              jantina : item.jantina,
              lkp_jurusan_id : item.lkp_jurusan_id,
              lkp_status_id : 1,
              copy : 0

          }

          this.getJurusan(item.lkp_ternakan_id)
          this.getBaka(item.lkp_jurusan_id)
          this.dialog.show = true
          this.dialog.title = 'Kemaskini'
          this.form.saveButton = "Kemaskini"
      },
      copy(item){
          
          this.table.items[0].id_ternakan = false
          this.table.items[0].kode = item.kode
          this.table.items[0].premis_id = item.premis_id
          this.table.items[0].lkp_ternakan_id = item.lkp_ternakan_id
          this.table.items[0].lookup.lkp_jurusan = item.lookup.lkp_jurusan
          this.table.items[0].lookup.lkp_baka = item.lookup.lkp_baka
          this.table.items[0].lkp_jurusan_id = item.lkp_jurusan_id
          this.table.items[0].lkp_gred_id = item.lkp_gred_id
          this.table.items[0].lkp_baka_id = item.lkp_baka_id
          this.table.items[0].jantina = item.jantina
          this.table.items[0].nama_bapa = item.nama_bapa
          this.table.items[0].id_bapa = item.id_bapa
          this.table.items[0].nama_ibu = item.nama_ibu
          this.table.items[0].id_ibu = item.id_ibu
          this.table.items[0].tarikh_lahir = item.tarikh_lahir
      },
      cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
       },

      resetPencarian() {
          this.$inertia.visit(route(route().current()));
       },
      getTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },

       getBaka(item){
         this.$zcomm.get(this.api_service + 'lookup/baka/'+item.lkp_jurusan_id, {}).then(res => {
           item.lookup.lkp_baka = res
         })
       },

       getbakaAll(){
         this.$zcomm.get(this.api_service + 'lookup/baka_all/', {}).then(res => {
           this.lkp_baka = res
         })
       },

       getjurusanAll(){
         this.$zcomm.get(this.api_service + 'lookup/jurusan_all/', {}).then(res => {
           this.lkp_jurusan = res
         })
       },

       getGred(){
         this.$zcomm.get(this.api_service + 'lookup/gred', {}).then(res => {
           this.lkp_gred = res
         })
       },

       getStatus(){
         this.$zcomm.get(this.api_service + 'lookup/status', {}).then(res => {
           this.lkp_status = res
         })
       },

       getJantina(){
         this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
           this.jantina = res
         })
       },

       getPremis(){
         this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
           this.premis = res
         })
       },

       getPremisCarian(){
         this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
           this.premis_id = res
         })
       },

       getJurusan(item){
         this.$zcomm.get(this.api_service + 'lookup/jurusan/'+item.lkp_ternakan_id, {}).then(res => {
           item.lookup.lkp_jurusan = res
         })
       },

        getJurusanCarian(i){
         this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
           this.lkp_jurusan = res
         })
       },

       getBakaCarian(i){
         this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
           this.lkp_baka = res
         })
       },



       getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'ternakan/show/'+this.id, {}).then(res => {
          if(res.lkp_ternakan_id > 0){
            this.getBaka(res.lkp_ternakan_id)
          }
          this.form = res

        })
      }
    },
    simpan(item){
      this.loading = true
      if(item.premis_id != '' && item.lkp_ternakan_id != '' && item.lkp_jurusan_id != '' && item.lkp_baka_id != '' &&  item.tarikh_lahir != '' && item.jantina ){
         if (item.id > 0) 
         {
           this.$zcomm.update(this.resourceurl + '.update', item.id, item)
           .then(res => {
             if (typeof this.onAfterEdit === "function") {
               this.onAfterEdit()
             }
             this.$inertia.visit(this.$route('daftar.ternakan.v2'))
           })
         }
         else 
         {
           this.$zcomm.post(this.resourceurl+'.store' , item)
           .then(res => {
             if (typeof this.onAfterAdd === "function") {
               this.onAfterAdd()
             }
             // this.$inertia.visit(this.$route('ternakan.index'))
             this.$inertia.visit(this.$page.url)

           })
         }
      }else if(item.premis_id == ''){
        this.loading = false
        this.$zutil.notify('Permis Wajib Isi', false)
      }else if(item.lkp_ternakan_id == ''){
        this.loading = false
         this.$zutil.notify('Jenis Ternakan Wajib Isi', false)
      }else if(item.lkp_jurusan_id == ''){
        this.loading = false
         this.$zutil.notify('Jurusan Wajib Isi', false)
      }else if(item.lkp_baka_id == ''){
        this.loading = false
         this.$zutil.notify('Baka Wajib Isi', false)
      }else if((item.id_ternakan == true  || item.id_ternakan == 1) && item.kode == ''){
         this.loading = false
         this.$zutil.notify('Id Ternakan Wajib Isi', false)
      }else if(item.tarikh_lahir == ''){
        this.loading = false
         this.$zutil.notify('Tarikh lahir Wajib Isi', false)
      }else if(item.jantina == ''){
        this.loading = false
         this.$zutil.notify('Jantina Wajib Isi', false)
      }
    },

       onSuccess(){
         if (this.form.id > 0) 
         {
           this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
           .then(res => {
             if (typeof this.onAfterEdit === "function") {
               this.onAfterEdit()
             }
             this.$inertia.visit(this.$route('ternakan.show', this.form.id))
           })
         }
         else 
         {
           this.$zcomm.post(this.resourceurl+'.store' , this.form)
           .then(res => {
             if (typeof this.onAfterAdd === "function") {
               this.onAfterAdd()
             }
             this.$inertia.visit(this.$route('ternakan.show', res.id))

           })
         }

       },
  
  },

  watch: {

  },
  mounted() {
if(this.id > 0)
    {
      this.title = 'Kemaskini Ternakan'
    }
    else
    {
      this.title = 'Tambah Ternakan'
    }
    this.getPremis()
    this.getJantina()
    this.getTernakan()
    this.getGred()
    this.getStatus()
    this.getData()
    this.getPremisCarian()
    this.getbakaAll()
    this.getjurusanAll()
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.premis_id){
      this.form.premis_id =  parseInt(this.params.premis_id)
    }
  }
}
</script>
